module.exports = __webpack_public_path__ + "img/loginBg.92816045.png";